export enum Category {
    DEFAULT = 'DEFAULT',
    ACCOUNT_HISTORY = 'ACCOUNT_HISTORY',
    ACCOUNT_LISTING = 'ACCOUNT_LISTING',
    PAYMENT = 'PAYMENT',
    TARGETED = 'TARGETED',
    TRANSFER = 'TRANSFER',
    MERCHANT_PAYMENT = 'MERCHANT_PAYMENT',  // Specific category to call merchant banner API
}

export enum Placement {
    SIDE = 'SIDE',
    BOTTOM = 'BOTTOM',
    CUSTOM_SIDE = 'CUSTOM_SIDE'
}


export interface Banner {
    name: string;
    link?: any;
    image: string;
    category: string;
    id?: number;            // Synthetic ID for Merchant Banner

    // clickable: boolean; // Do not refer in web
    // mobiBranch: boolean;// Do not refer in web
    // contentType: string;// Do not refer in web
    // code?: any;         // Do not refer in web
    // text?: any;         // Do not refer in web
}

// {
//     "status": {
//         "code": 0,
//         "message": "OK"
//     },
//     "message": "OK",
//     "validationErrorList": [],
//     "entity": {
//         "clickable": false,
//         "mobiBranch": false,
//         "link": null,
//         "image": "/api/v1/external/banner/TARGETED/BOTTOM/4",
//         "code": null,
//         "text": null,
//         "contentType": "image/gif",
//         "name": "bannerT4",
//         "category": "ACCOUNT_LISTING"

//     }
// }

export enum BannerView {
    BROWSER = 'BROWSER',
    MOBILE = 'MOBILE',
}

export interface MerchantBanner {
  id: number;
  merchantId: number;
  name: string;
  link: null | string;
}